var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Welcome, ")]),_c('div',{staticClass:"alert alert-info"},[_vm._v(" "+_vm._s(_vm.userInfo)+" ")]),_c('router-link',{attrs:{"to":"/logout"}},[_vm._v(" Logout ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }